import { isEmpty } from 'lodash';
import { metricsDataExtractor } from 'modules/iterableGoals/utils/goalAnalytics';
import { ActionTypes } from '../actionTypes';
import {
  GoalAnalyticsMetricKey,
  GoalContributionsByMediumAction,
  GoalContributionsByMediumState,
  KeyofGoalAnalyticsMetricValue,
} from '../../types';

export const initialGoalContributionsByMediumState = {
  metrics: {},
  loading: true,
  error: false,
};

export const goalContributionsByMediumReducer = (
  state: GoalContributionsByMediumState = initialGoalContributionsByMediumState,
  action?: GoalContributionsByMediumAction,
) => {
  const metrics = action?.payload?.metrics;
  const hasData = !isEmpty(metrics);

  switch (action?.type) {
    case ActionTypes.FETCH_CONTRIBUTIONS_BY_MEDIUM_REQUEST:
    case ActionTypes.FETCH_GOAL_ANALYTICS_REQUEST:
      return {
        ...state,
        error: false,
        loading: true,
      };
    case ActionTypes.FETCH_CONTRIBUTIONS_BY_MEDIUM_RESPONSE:
      return {
        ...state,
        error: false,
        metrics: action?.payload,
        loading: false,
      };
    case ActionTypes.FETCH_GOAL_ANALYTICS_RESPONSE:
      return {
        ...state,
        error: false,
        metrics:
          metrics && hasData
            ? metricsDataExtractor(metrics, [
                [
                  GoalAnalyticsMetricKey.TOTAL_GOAL_CONVERSIONS,
                  KeyofGoalAnalyticsMetricValue.MEDIUM,
                ],
                [GoalAnalyticsMetricKey.TOTAL_SENT, KeyofGoalAnalyticsMetricValue.MEDIUM],
                [GoalAnalyticsMetricKey.REVENUE, KeyofGoalAnalyticsMetricValue.MEDIUM],
              ])
            : state.metrics,
        loading: false,
      };
    case ActionTypes.FETCH_CONTRIBUTIONS_BY_MEDIUM_ERROR:
    case ActionTypes.FETCH_GOAL_ANALYTICS_ERROR:
      return {
        ...initialGoalContributionsByMediumState,
        error: true,
        loading: false,
      };
    default:
      return state;
  }
};
